import { postRequest } from './responseDecoder'
import { API_BASE } from '../components/PropertySearch/utils'

export const INSURANCE_VERSION = 'insurance-v2'
export const INSURANCE_PROFILES = ['owner_occupier', 'investment']
export const pendingInsurance = () => ({ insurance_version: INSURANCE_VERSION, state: 'pending', status: 'Unknown', profiles: {} })
export const failedInsurance = () => ({ insurance_version: INSURANCE_VERSION, state: 'failed', status: 'Unknown', profiles: {}, save_state: 'unconfirmed' })

const strings = value => Array.isArray(value) ? value.filter(item => typeof item === 'string' && item.trim()) : []
const sources = value => strings(value).filter(url => /^https?:\/\//i.test(url))
function benchmark(data) {
  const range = typeof data?.estimated_range === 'string' && data.estimated_range.trim() && !/^(n\/?a|unknown|unavailable)$/i.test(data.estimated_range.trim()) ? data.estimated_range : null
  return { ...data, sources: sources(data?.sources), estimated_range: range, assumptions: strings(data?.assumptions) }
}
const supported = data => data.estimated_range && data.sources.length > 0

export function normalizeInsuranceEstimate(data) {
  const known = data?.insurance_version === INSURANCE_VERSION
  const notRecorded = !known || data?.error_code === 'not_researched'
  const profiles = Object.fromEntries(INSURANCE_PROFILES.map(key => {
    const raw = known ? data?.profiles?.[key] : null
    const value = benchmark(raw)
    const expectedCoverage = key === 'owner_occupier' ? 'home_and_contents' : 'building_and_landlord'
    const local = ['property', 'suburb', 'postcode'].includes(value.geographic_scope?.level)
    const context = (Array.isArray(raw?.regional_context) ? raw.regional_context : []).map(benchmark)
      .filter(item => supported(item) && ['state', 'national'].includes(item.geographic_scope?.level))
    // Preserve older broad evidence as background, never as a local estimate.
    if (data?.insurance_version === 'insurance-v1' && data.state === 'available') {
      const old = benchmark(data)
      const target = data.coverage === 'building_and_landlord' ? 'investment' : 'owner_occupier'
      if (key === target && supported(old) && ['state', 'national'].includes(old.geographic_scope?.level)) context.push(old)
    }
    const state = known && data.state === 'pending' ? 'pending'
      : known && (data.state === 'failed' || raw?.state === 'failed') ? 'failed'
        : !notRecorded && raw?.error_code !== 'not_researched' && raw?.state === 'available' && raw.coverage === expectedCoverage && local && supported(value) ? 'available' : 'unavailable'
    return [key, { ...value, state, not_recorded: notRecorded || !raw || raw.error_code === 'not_researched',
      status: state === 'available' && ['Average', 'Higher', 'Lower'].includes(raw?.status) ? raw.status : 'Unknown',
      estimated_range: state === 'available' ? value.estimated_range : null,
      missing_inputs: strings(raw?.missing_inputs), regional_context: context }]
  }))
  const values = Object.values(profiles)
  const state = known && ['pending', 'failed'].includes(data.state) ? data.state
    : values.some(item => item.state === 'available') ? 'available' : 'unavailable'
  return { ...data, state, profiles, not_recorded: notRecorded,
    status: values.some(item => item.status === 'Higher') ? 'Higher' : 'Unknown',
    needs_review: values.some(item => item.state !== 'available' || item.status === 'Higher'),
    estimated_range: null }
}

export async function requestInsuranceEstimate(address, forceRefresh = false) {
  const response = await postRequest(`${API_BASE}/api/v1/property-insurance-estimate`,
    { address, ...(forceRefresh ? { force_refresh: true } : {}) },
    { signal: AbortSignal.timeout(180000) })
  return normalizeInsuranceEstimate(response?.insurance_estimate)
}
